import React, { useEffect } from 'react';
import { Cards, Icon } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';

const pageSize = 20;

export const AdminPage = () => {
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    useEffect(() => {
        //handleRefresh();
    }, []);
    const handleOption = (ref:string) => {
        window.location.href=ref
    }
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Administradores', href: '#transcription-job-list' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>

                    <Cards
                        ariaLabels={{
                            itemSelectionLabel: (e, i) => `select ${i.name}`,
                            selectionGroupLabel: "Item selection"
                        }}
                        selectionType="single"
                        onSelectionChange={({ detail }) => handleOption(detail.selectedItems[0].id)}
                        cardDefinition={{
                            
                            header: item => item.name
                            ,
                            sections: [
                                {
                                    header: "Descripción",
                                    content: item => item.description
                                },
                            ]
                        }}
                        cardsPerRow={[
                            { cards: 1 },
                            { minWidth: 500, cards: 3 }
                        ]}
                        entireCardClickable
                        items={[
                            {
                                id:"#admin/users",
                                name: "Usuarios",
                                description: "Usuarios internos de la administración de esta propiedad",
                            },
                            {
                                id:"#admin/properties",
                                name: "Propiedades",
                                description: "Cambiar de propiedad para administrar",
                            },
                        ]}
                        header={<Header><Icon name="script"></Icon> Opciones</Header>}
                    />
                </>
            }
        />
    );
};
